export default __webpack_public_path__ + "static/Leanne_Walsham_CV-f893b426bfac13431cbb2f27c77813f2.pdf";